import { render, staticRenderFns } from "./GoogleTranslate.vue?vue&type=template&id=f44ec3f6&scoped=true"
import script from "./GoogleTranslate.vue?vue&type=script&lang=js"
export * from "./GoogleTranslate.vue?vue&type=script&lang=js"
import style0 from "./GoogleTranslate.vue?vue&type=style&index=0&id=f44ec3f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44ec3f6",
  null
  
)

export default component.exports